import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPoicy() {
  return (
    <div className="p-6">
      <h1 className="text-3xl text-center font-bold">Privacy Policy</h1>

      <div className="p-5 ">
        <p>
          At{" "}
          <Link className="cursor-pointer text-blue-500" to={"/"}>
            Mariniz.com
          </Link>{" "}
          (“we,” “our,” “us”), we value your trust and are committed to
          protecting your privacy. This Privacy Policy explains how we collect,
          use, and safeguard your personal information when you visit{" "}
          <Link className="cursor-pointer text-blue-500" to={"/"}>
            {" "}
            https://mariniz.com
          </Link>
          , use our services, or communicate with us.
        </p>

        <p>
          By accessing our website or using our services, you agree to the terms
          of this Privacy Policy.
        </p>

        <ul className="mt-4 space-y-5">
          <li>
            <p className="font-semibold">
              {" "}
              1. Information We Collect We collect two main types of
              information:
            </p>

            <p>1.1 Personal Information Provided directly by you when you: </p>
            <div className="ml-4">
              <p>Register a vessel for sale or charter</p>

              <p>Submit an enquiry or request information</p>

              <p>Sign up for our newsletter or promotions</p>

              <p>Make a payment for our services</p>

              <p>This may include:</p>

              <p>Name</p>

              <p>Email address</p>

              <p>Phone/WhatsApp number</p>

              <p>Company name and address</p>

              <p>Vessel details (type, specifications, price, etc.)</p>

              <p>Payment or billing information (if applicable)</p>

              <p>
                Collected automatically when you visit our website, including:
              </p>

              <p>IP address</p>

              <p>Browser type and version</p>

              <p>Device type and operating system</p>

              <p>Pages visited and time spent</p>

              <p>Referral source (e.g., search engine, social media)</p>
            </div>
          </li>

          <li>
            <p className="font-semibold">2. How We Use Your Information</p>
            <div className="ml-4">
              <p>We use the information we collect to:</p>

              <p>Publish and manage vessel listings</p>
              <p>Connect buyers, sellers, and charterers</p>
              <p>Respond to your messages and enquiries</p>
              <p>
                Send updates, newsletters, and promotional offers (opt-out
                available)
              </p>
              <p>Improve our website’s performance, security, and content</p>
              <p>Fulfill legal and regulatory requirements</p>
            </div>
          </li>

          <li>
            <p className="font-semibold">3. How We Share Your Information</p>
            <div className="ml-4">
              <p>We may share your information in the following cases:</p>
              <p>
                With interested parties – if you have listed a vessel or
                requested vessel information
              </p>
              <p>
                With trusted service providers – such as hosting companies,
                payment processors, and email marketing platforms
              </p>
              <p>
                For legal reasons – if required by law, regulation, or court
                order
              </p>
              <p>
                We do not sell or rent your personal data to third parties for
                marketing purposes.
              </p>
            </div>
          </li>

          <li>
            <p className="font-semibold">4. Cookies and Tracking</p>
            <div className="ml-4">
              <p>We use cookies and similar technologies to:</p>
              <p>Remember your preferences</p>
              <p>Measure website performance</p>
              <p>Improve marketing campaigns</p>
              <p>You can manage cookie settings via your browser.</p>
            </div>
          </li>

          <li>
            <p className="font-semibold">5. Data Retention</p>
            <p className="ml-4">
              We retain personal information only for as long as needed to
              provide services, comply with legal obligations, or resolve
              disputes.
            </p>
          </li>

          <li>
            <p className="font-semibold">6. Data Security</p>
            <p className="ml-4">
              We implement industry-standard measures, including SSL encryption
              and secure hosting, to protect your data. However, no internet
              transmission is entirely secure.
            </p>{" "}
          </li>

          <li>
            <p className="font-semibold">7. Your Rights</p>
            <div className="ml-4">
              <p>
                Depending on your location (e.g., GDPR, CCPA), you may have the
                right to:
              </p>
              <p>Access, update, or delete your personal information</p>
              <p>Restrict or object to certain data processing activities</p>
              <p>Withdraw consent at any time</p>
              <p>Request a copy of your data</p>
              <p>
                To exercise your rights, contact us at  <Link className="text-blue-500 cursor-pointer" to={"mailto:info@mariniz.com"}>info@mariniz.com</Link> or +971 50
                350 5898.
              </p>{" "}
            </div>
          </li>

          <li>
            <p className="font-semibold">8. International Transfers</p>
            <p className="ml-4">
              Your information may be stored or processed in countries outside
              your location. We ensure appropriate safeguards for such
              transfers.
            </p>
          </li>

          <li>
            <p className="font-semibold">9. Third-Party Links</p>
            <p className="ml-4">
              Our site may contain links to third-party websites. We are not
              responsible for their privacy practices—please review their
              policies before sharing data.
            </p>
          </li>

          <li>
            <p className="font-semibold">10. Changes to This Policy</p>
            <p className="ml-4">
              We may update this Privacy Policy from time to time. Changes will
              be posted on this page with the updated effective date.
            </p>
          </li>

<li>
            <p className="font-semibold">11. Contact Us</p>
            <div className="ml-4 ">
              <p>
                <Link to={"/"} className="cursor-pointer  text-blue-500">
                  Mariniz.com
                </Link>
              </p>
              <p>302, Al Ansari Building, Dubai, UAE</p>
              <p>Email: <Link className="text-blue-500 cursor-pointer" to={"mailto:info@mariniz.com"}>info@mariniz.com</Link></p>
              <p>Phone: +971 50 350 5898</p>
              <p>
                Website:{" "}
                <Link to={"/"} className="cursor-pointer text-blue-500">
                  https://mariniz.com
                </Link>
              </p>
            </div>
</li>
        </ul>
      </div>
    </div>
  );
}
